module.exports = __webpack_public_path__ + "img/crimson_robe.520302ae.png";